import { push, replace } from 'connected-react-router';
import { saveAs } from 'file-saver';
import { actions as notifications } from '@saucelabs/sl-container-notifications';

import { SESSION_INACTIVE_REASONS } from '../../constants';
import actions from './actions';
import selectors from './selectors';
import utils from './utils';

const connectToChannel = (sessionId) => async (dispatch) => {
  try {
    await actions.getChannelStatusRequest(sessionId);
    await Promise.all([
      dispatch(actions.connectChannel(sessionId)),
      dispatch(actions.getSessionInfo(sessionId)),
    ]);
  } catch (error) {
    const payload = { code: error.response?.status ?? 500 };

    if (payload.code === 410) {
      payload.reason = SESSION_INACTIVE_REASONS.INACTIVE;
    }

    dispatch(actions.getChannelStatusFailure(payload));
  }
};

const startSession = (payload) => async (dispatch) => {
  dispatch(push('/live/lsm'));

  const sessionData = await dispatch(actions.createSession(payload));

  dispatch(replace(`/live/lsm/${sessionData.session_id}`));
};

const takeScreenshot = () => async (dispatch, getState) => {
  const metadata = selectors.metadataSelector(getState());
  const filename = utils.createScreenshotName(metadata);

  try {
    const screenshot = await dispatch(actions.takeScreenshot());
    if (screenshot?.data) {
      saveAs(`data:image/png;base64,${screenshot.data}`, filename);
      dispatch(notifications.notifySuccess('Screenshot saved to Test Details page and to the Downloads folder on your computer.'));
    } else {
      throw new Error('The retrieved screenshot has no data.');
    }
  } catch (error) {
    dispatch(notifications.notifyDanger('Failed to save the screenshot, please try again.'));
    throw error;
  }
};

const stopSession = () => (dispatch, getState) => {
  const { user, apps: { manual: { liveSessionManager } } } = getState();

  if (user.id === liveSessionManager.session.owner) {
    dispatch(actions.closeSession());
  }
};

export default {
  connectToChannel,
  startSession,
  stopSession,
  takeScreenshot,
};
